import React from 'react';
import { motion } from 'framer-motion';
import { FileText, Map, BookOpen, CheckSquare, Globe } from 'lucide-react';
export function WhatYouGet() {
  const items = [{
    icon: <FileText className="w-8 h-8 text-navy-dark" data-id="element-166" />,
    title: 'Guía de Libertad Fiscal',
    desc: 'El manual completo PDF paso a paso.'
  }, {
    icon: <Map className="w-8 h-8 text-navy-dark" data-id="element-167" />,
    title: 'El Mapa de Impuestos $0',
    desc: 'Enlaces directos a los portales ocultos del IRS.'
  }, {
    icon: <BookOpen className="w-8 h-8 text-navy-dark" data-id="element-168" />,
    title: 'Diccionario de Deducciones 1099',
    desc: 'Identifica los gastos de negocio que tu preparador suele olvidar.'
  }, {
    icon: <CheckSquare className="w-8 h-8 text-navy-dark" data-id="element-169" />,
    title: 'Lista de Verificación Anti-Errores',
    desc: 'Revisa tu declaración antes de enviarla.'
  }, {
    icon: <Globe className="w-8 h-8 text-navy-dark" data-id="element-170" />,
    title: 'Directorio de Declaración Estatal Gratuita',
    desc: 'No vuelvas a pagar por tus impuestos del estado.'
  }];
  return <section className="bg-offwhite py-20 md:py-28" data-id="element-171">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-172">
        <div className="text-center mb-16" data-id="element-173">
          <h2 className="text-4xl md:text-5xl font-bold text-navy-dark uppercase mb-4" data-id="element-174">
            Lo que obtienes hoy
          </h2>
          <div className="w-24 h-1 bg-gold-accent mx-auto" data-id="element-175"></div>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8" data-id="element-176">
          {items.map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: idx * 0.1
        }} className="bg-white p-8 rounded-xl shadow-lg border-t-4 border-gold-accent hover:-translate-y-1 transition-transform duration-300" data-id="element-177">
              <div className="bg-offwhite w-16 h-16 rounded-full flex items-center justify-center mb-6" data-id="element-178">
                {item.icon}
              </div>
              <h3 className="text-2xl font-bold text-navy-dark font-heading mb-3" data-id="element-179">
                {item.title}
              </h3>
              <p className="text-gray-600 font-body text-lg" data-id="element-180">{item.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}